import { ADD_ACTIVITY_BANNER_ACTION, UPDATE_ACTIVITY_BANNER_ACTION } from "../constants/activityBannerConstants";


// /** Adds an activity banner message to the banner queue.
//  * 
//  * @param {Object} bannerMessage - The banner message to be added to the queue.
//  * @param {string} bannerMessage.messageId - Unique identifier for the banner message.
//  * @param {string} bannerMessage.title - Title of the banner message.
//  * @param {string} bannerMessage.message - Content of the banner message.
//  * @param {number} bannerMessage.progress - Progress value for the banner message (e.g., 0-100).
//  * @param {number} bannerMessage.variant - 'text' or 'progress'
//  * @returns 
//  */
export const addActivityBannerMessage = (bannerMessage) => async (dispatch) => {
    if (!bannerMessage.messageId) {
        throw new Error("message id is required");
    }
    dispatch({
        type: ADD_ACTIVITY_BANNER_ACTION,
        payload: {
            ...bannerMessage,
            messageTime: Date.now()},
    });
};


// /** this action updates an existing banner message in the queue can be used to
//  * 
//  * @param {Object} bannerMessage - The banner message to be added to the queue.
//  * @param {string} bannerMessage.messageId - Unique identifier for the banner message.
//  * @param {string} bannerMessage.title - Title of the banner message.
//  * @param {string} bannerMessage.message - Content of the banner message.
//  * @param {number} bannerMessage.progress - Progress value for the banner message (e.g., 0-100).
//  * @param {number} bannerMessage.variant - 'text' or 'progress'
//  * @returns 
//  */
export const updateActivityBannerMessage = (bannerMessage) => async (dispatch) => {
    if (!bannerMessage.messageId) {
        throw new Error("message id is required");
    }
    dispatch({
        type: UPDATE_ACTIVITY_BANNER_ACTION,
        payload: {
            ...bannerMessage,
            messageTime: Date.now()},
    });
};

